import React, { useState } from 'react';

const TreeTableRow = ({ langLocal, translate, data, depth, setOpen, setzone_id, setEditObj, setOpen1 }) => {
    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpanded = (item, id) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [id]: item?.materials?.status ? true : !prevState[id]
        }));
    };

    const [checked, setChecked] = useState(false);

    const handleCheckboxChange = () => {
        setChecked(!checked);
    };

    return (
        <>
            {data.map(item => (
                <React.Fragment key={item.id}>
                    <tr dir={langLocal === 'ar' ? "rtl" : "ltr"} style={item?.materials ? { backgroundColor: "#d9fef0" } : {}} >
                        <td style={{ width: "90px", textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }} >
                            <input type="checkbox" checked={checked} onChange={handleCheckboxChange} />
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <div style={langLocal === 'ar' ? { marginRight: `${depth * 20}px`, cursor: 'pointer' } :
                                { marginLeft: `${depth * 20}px`, cursor: 'pointer' }} onClick={() => toggleExpanded(item, item.id)}>
                                <div className='d-flex' >
                                    {item.name}
                                    {item.sub_zones && item.sub_zones.length > 0 && (
                                        <div onClick={() => toggleExpanded(item, item.id)} style={{ cursor: 'pointer' }}>
                                            <i style={langLocal === 'ar' ? { marginRight: "10px" } :
                                                { marginLeft: "10px" }
                                            } className={`fas fa-caret-${expandedRows[item.id] ? 'down' : 'right'}`}></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <span>{item.symbol}</span>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <span>{item?.materials?.zone || `-`} </span>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <span>{item?.materials?.quantity || `-`}</span>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <div>
                                <i className='fa fa-plus plus_zone' onClick={() => {
                                    setOpen(true)
                                    setzone_id(item.id)
                                }} ></i>
                                {/*<i style={{ marginLeft: "10px" }} className='fa fa-edit edit_zone' onClick={() => {
                                    setEditObj(item)
                                    setOpen1(true)
                                }} ></i>*/}
                            </div>
                        </td>
                    </tr>
                    {
                        item.sub_zones && item.sub_zones.length > 0 && (
                            <>
                                <TreeTableRow langLocal={langLocal} translate={translate} setOpen1={setOpen1} data={item.sub_zones} depth={depth + 1} setOpen={setOpen} setzone_id={setzone_id} setEditObj={setEditObj} />
                            </>
                        )
                    }
                </React.Fragment>
            ))}
        </>
    );
};

function TreeTableMovements({ langLocal, translate, columns, data, open, setOpen, setzone_id, setEditObj, setOpen1 }) {
    return (
        <table className="tree-table">
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }} key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <TreeTableRow langLocal={langLocal} translate={translate} setOpen={setOpen} setzone_id={setzone_id} data={data} depth={0} setEditObj={setEditObj} setOpen1={setOpen1} />
            </tbody>
        </table>
    );
}

export default TreeTableMovements;